<template>
    <section class="center-element form-container">
        <br />
        <br />
        <header class="form-title">
            <span>{{ titlePageText }}</span>
        </header>
        <eg-alert :show="show" :message="message" color="red" @show="show = $event" />
        <div class="form-row">
            <header :style="typePage ? 'margin-bottom: 0px !important' : ''">
                <p>Quais os principais serviços que você realiza?</p>
                <span v-if="allCategoriesValidation" class="error">Selecione categorias distintas.</span>
            </header>
            <div class="categories-container" ref="categories">
                <div v-for="(categoryInput, choiceIndex) in categories" class="category" :key="choiceIndex">
                    <div v-show="!typePage" class="category-label">
                        Opção {{ parseInt(choiceIndex) + 1 }}<span v-if="choiceIndex == 0">*</span>
                    </div>
                    <multiselect
                        v-model="categoryInput.category"
                        placeholder="Selecionar"
                        label="name"
                        track-by="id"
                        :preserve-search="true"
                        :options="allCategories"
                        :options-limit="400"
                        :limit="10"
                        :allow-empty="true"
                        :searchable="true"
                        :multiple="false"
                        :select-label="select2Options.selectLabel"
                        :selected-label="select2Options.selectedLabel"
                        group-values="tagServices"
                        group-label="order"
                        :group-select="false"
                    >
                        <span slot="noResult">{{ select2Options.noResultsLabel }}</span>
                    </multiselect>
                </div>
            </div>
        </div>
        <div v-if="!typePage || typePage == 'contactUs'" class="form-row">
            <header>
                <p>Qual o cargo que você ocupa na sua empresa?*</p>
                <eg-select
                    @input="option => (position = option.value)"
                    :options="positionOptions"
                    placeholder-text="Selecione seu cargo"
                    identifier="position-select"
                    ref="position"
                />
            </header>
        </div>
        <div class="form-row">
            <header>
                <p>Quantos funcionários sua empresa possui?*</p>
                <eg-select
                    @input="option => (employeeTotal = option.value)"
                    :options="employeeTotalOptions"
                    placeholder-text="Selecione um valor"
                    identifier="employee-select"
                    ref="employeeTotal"
                />
            </header>
        </div>
        <div class="form-row">
            <header>
                <p>Qual a média de faturamento anual da sua empresa?*</p>
                <eg-select
                    @input="option => (monthlyRevenue = option.value)"
                    :options="monthlyRevenueOptions"
                    placeholder-text="Selecione um valor"
                    identifier="revenue-select"
                    ref="monthlyRevenue"
                />
            </header>
        </div>
        <div v-if="!typePage" class="form-row">
            <header class="header-radios">
                <p>Sua empresa parcela obras em condomínios?*</p>
            </header>
            <div>
                <div class="radios-label">
                    <label>
                        <input type="radio" :value="true" v-model="worksInCondo" />
                        Sim
                    </label>
                    <label>
                        <input type="radio" :value="false" v-model="worksInCondo" />
                        Não
                    </label>
                </div>
            </div>
        </div>
                <div v-if="!typePage" class="form-row">
            <header class="header-radios">
                <p>Sua empresa possui algum contrato ativo em condomínio?*</p>
            </header>
            <div>
                <div class="radios-label">
                    <label>
                        <input type="radio" :value="true" v-model="contractWithCondo" />
                        Sim
                    </label>
                    <label>
                        <input type="radio" :value="false" v-model="contractWithCondo" />
                        Não
                    </label>
                </div>
            </div>
        </div>
                        <div v-if="!typePage && contemId3" class="form-row">
            <header class="header-radios">
                <p>Sua empresa adquiriu materiais de impermeabilização no último ano?*</p>
            </header>
            <div>
                <div class="radios-label">
                    <label>
                        <input type="radio" :value="true" v-model="buyWaterproofingMaterials" />
                        Sim
                    </label>
                    <label>
                        <input type="radio" :value="false" v-model="buyWaterproofingMaterials" />
                        Não
                    </label>
                </div>
            </div>
        </div>
        <!-- <div v-if="!typePage" class="form-row">
            <header>
                <p>Quais tipos de investimento em marketing digital você faz?*</p>
            </header>
            <div class="digital-marketing-options" ref="digitalMarketing">
                <div v-for="(option, index) in digitalMarketingOptions" :key="`option-${index + 1}`" class="option">
                    <input
                        type="checkbox"
                        class="filled-in"
                        :id="`option-${index + 1}`"
                        :value="option.value"
                        v-model="digitalMarketing"
                    />
                    <label :for="`option-${index + 1}`">{{ option.label }}</label>
                </div>
            </div>
            <eg-input
                v-show="digitalMarketing.includes('other')"
                v-model="otherDigitalMarketing"
                input-type="text"
            ></eg-input>
        </div> -->
        <!-- <div class="form-row">
            <header>
                <p v-if="!typePage">
                    Qual o valor total do investimento mensal?*
                    <span class="subtitle">(Caso não faça investimento, selecione a primeira opção)</span>
                </p>
                <p v-else>
                    Qual o valor total do investimento mensal em marketing digital?*
                    <span class="subtitle"> (Caso não faça investimento, selecione a primeira opção)</span>
                </p>
                <eg-select
                    @input="option => (monthlyDigitalMarketingInvestment = option.value)"
                    :options="digitalMarketingInvestment"
                    placeholder-text="Selecione um valor"
                    identifier="digital-marketing-investment-select"
                    ref="digitalMarketingInvestment"
                />
            </header>
        </div> -->
        <br/>
        <div v-if="!typePage" class="form-row">
            <header :style="typePage ? 'margin-bottom: 0px !important' : ''">
                <span>Como conheceu a Engelink?*</span>
            </header>
            <eg-input class="input-field" :value="origin" v-model="origin" placeholder-text="Digite a origem" />
        </div>

        <div v-if="!typePage" class="form-row">
            <eg-textarea
                class="input-field"
                title="Escreva um pouco sobre a sua empresa"
                v-model="aboutCompany"
                :value="aboutCompany"
            ></eg-textarea>
        </div>

        <div class="btn-end">
            <eg-button @click="validateForm" :disabled="loadingForm" :loading="loadingForm"> Finalizar </eg-button>
        </div>
        <br />
        <br />
        <br />
        <br />
        <successSubscriptionModal :show="showModal" @close="(show = false), redirect()" />
    </section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { getSupplierCategories } from '@/services/api/quotation';
import {
    getSupplier,
    getCheckSubscription,
    sendAssociateComplementContactUs,
    sendAssociateComplementSubscriptionNotification
} from '@/services';
import { supplierUpdateProfile } from '@/services/api/supplier';
import { mapActions } from 'vuex';
import { MAIN_TAGS_SUPPLIERS } from '@/utils/constants';
import successSubscriptionModal from '@/components/modal/subscription-alert/subscription-notification';

export default {
    name: 'SupplierComplement',
    components: { successSubscriptionModal },
    data: () => ({
        message: '',
        show: false,
        showModal: false,
        monthlyRevenue: '',
        employeeTotal: '',
        position: '',
        categories: [{ category: '' }],
        digitalMarketing: [],
        monthlyDigitalMarketingInvestment: '',
        origin: '',
        otherDigitalMarketing: '',
        worksInCondo: null,
        contractWithCondo: null,
        buyWaterproofingMaterials: null,
        contemId3: false,
        monthlyRevenueOptions: [
            { label: 'Até R$ 200 mil', value: '0' },
            { label: 'De R$ 200 mil até R$ 600 mil', value: '200' },
            { label: 'Acima de R$ 600 mil', value: '601' }
        ],
        digitalMarketingOptions: [
            { label: 'Google Ads', value: 'google-ads' },
            { label: 'Facebook Ads', value: 'facebook-ads' },
            { label: 'Agência de marketing', value: 'marketing-agency' },
            { label: 'Plataforma digital', value: 'digital-platform' },
            { label: 'Nenhuma forma de investimento', value: 'none' },
            { label: 'Outro', value: 'other' }
        ],
        digitalMarketingInvestment: [
            { label: 'Não faço investimentos', value: '0' },
            { label: 'R$ 0,01 a R$ 500,00', value: '1' },
            { label: 'R$ 501,00 a R$ 1.000,00', value: '501' },
            { label: 'R$ 1.001,00 a R$ 5.000,00', value: '1001' },
            { label: 'Acima de R$ 5.000,00', value: '5001' }
        ],
        employeeTotalOptions: [
            { label: 'Não possuo funcionários', value: '0' },
            { label: '1 a 5', value: '1' },
            { label: '6 a 10', value: '6' },
            { label: '11 a 25', value: '11' },
            { label: '26 a 50', value: '26' },
            { label: 'Mais de 50', value: '50' }
        ],
        positionOptions: [
            { label: 'Sócio/Proprietário/CEO', value: 'owner' },
            { label: 'Diretor', value: 'director' },
            { label: 'Gerente', value: 'manager' },
            { label: 'Outro', value: 'other' }
        ],
        select2Options: {
            selectedLabel: 'Selecionado',
            selectLabel: 'Selecionar',
            noResultsLabel: 'Nenhum resultado encontrado.'
        },
        supplierId: '',
        hasSubscription: false,
        uniqueCategories: false,
        loadingForm: false,
        aboutCompany: '',
        allCategories: [
            {
                order: 'Serviços mais buscados',
                tagServices: MAIN_TAGS_SUPPLIERS
            },
            {
                order: 'Outros serviços',
                tagServices: []
            }
        ]
    }),
    async created() {
        this.typePage
            ? (this.categories = [{ category: '' }])
            : (this.categories = [{ category: '' }, { category: '' }, { category: '' }]);
        this.allCategories[1].tagServices = await getSupplierCategories();
        await this.getSupplier();
        try {
            await this.getSubscription();
        } catch (e) {
            this.hasSubscription = false;
        }
    },
    methods: {
        ...mapActions('user', ['setUserInformation']),
        async getSupplier() {
            if (!this.typePage) {
                const data = await getSupplier();
                const supplier = data.length > 0 ? data[0] : undefined;
                if (supplier) this.supplierId = supplier.id;
            }
        },
        async getSubscription() {
            if (!this.typePage) {
                const data = await getCheckSubscription();
                this.hasSubscription = !_.isEmpty(data) && data.isActive;
            }
        },
        async updateProfile() {
            try {
                const payload = await this.makePostData();
                await supplierUpdateProfile(payload, this.supplierId);
                await this.setUserInformation();
                this.redirect();
            } catch (e) {
                console.log(e);
            }
        },
        async makePostData() {
            // let digitalMarketing = this.digitalMarketing;
            // if (this.otherDigitalMarketing) {
            //     digitalMarketing = digitalMarketing.concat(this.otherDigitalMarketing);
            // }
            const { category } = this.categories[0];
            const payload = {
                categories: [category.name],
                tags: this.selectedCategories,
                [this.typePage ? 'main_category' : 'main_tag']: this.typePage
                    ? category.name
                    : category.id,
                position: this.position,
                employee_total: this.employeeTotal,
                total_revenue: this.monthlyRevenue,
                // monthly_digital_marketing_investment: this.monthlyDigitalMarketingInvestment,
                origin: this.origin,
                // digital_marketing: digitalMarketing,
                aboutCompany: this.aboutCompany,
                works_in_condo: this.worksInCondo,
                contract_with_condo: this.contractWithCondo,
                buy_waterproofing_materials: this.buyWaterproofingMaterials
            };
            return payload;
        },
        async makeSubmitForm() {
            this.loadingForm = true;
            try {
                const id = this.$cookies.get('complement_info');
                if (this.typePage) {
                    if (this.typePage == 'specialist') {
                        const payload = await this.makePostData();
                        await sendAssociateComplementSubscriptionNotification(id, payload);
                    } else {
                        const payload = await this.makePostData();
                        await sendAssociateComplementContactUs(id, payload);
                    }
                } else {
                    await this.updateProfile();
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.loadingForm = false;
                if (this.typePage) {
                    this.showModal = true;
                }
            }
        },
        redirect() {
            if (this.typePage) {
                // se vier do fluxo do especialista ou fale conosco para lidar com assinatura
                this.$router.push({ name: 'CompetitionDashboardGuest' });
            } else if (this.hasSubscription) {
                // se tem inscrição vai para home
                this.$router.push({ name: 'DashboardSupplier' });
            } else {
                // caso não tenha vai para lista de cotações
                this.$router.push({ name: 'CompetitionDashboard' });
            }
        },
        validateForm() {
            if (!this.allCategoriesValidation && this.formValidation) {
                this.makeSubmitForm();
            } else {
                this.message = 'Preencha os campos obrigatórios';
                this.show = true;
                window.scrollTo(0, 0);
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        typePage() {
            return this.$route.meta.complement;
        },
        titlePageText() {
            if (this.$route.meta.complement) {
                return 'Nos ajude a entender melhor sua necessidade!';
            } else {
                return 'Nos ajude a entregar as melhores ofertas a você';
            }
        },
        allCategoriesValidation() {
            let error = false;
            if (!this.typePage) {
                this.categories.forEach(({ category }, index) => {
                    if (category == this.categories[index + index > 2 ? 0 : index + 1].category && category != '') {
                        error = true;
                    }
                });
            }
            return error;
        },
        formValidation() {
            if (
                this.selectedCategories.length &&
                (!this.typePage || this.typePage == 'contactUs' ? this.position.trim() != '' : true) &&
                this.employeeTotal.trim() != '' &&
                this.monthlyRevenue.trim() != '' &&
                // this.monthlyDigitalMarketingInvestment.trim() != '' &&
                // (this.typePage ? true : this.digitalMarketing.length) &&
                (this.typePage ? true : this.origin.trim() != '') && (this.worksInCondo !== null) && (this.contractWithCondo !== null)
            ) {
                return true;
            }
            return false;
        },
        selectedCategories: function() {
            const categories = this.categories.map(element => element.category.name);

            const allCategories = this.allCategories[1].tagServices.filter(item => categories.includes(item.name));

            const ids = allCategories.map(element => element.id);

            return ids.filter(element => !!element);
        },
    },
  watch: {
    categories: {
      handler(newVal, oldVal) {
        const contemId3 = newVal.some(item => item.category.id === 3);
        this.contemId3 = contemId3
      },
      deep: true
    }
  },
};
</script>

<style>
.form-container {
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.form-container .form-title {
    color: var(--color--dark-blue);
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    width: 100%;
    margin-bottom: 64px;
}
.form-container .form-row {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 15px;
}
.form-container .form-row header {
    margin-bottom: 15px;
}
.form-container .form-row header label {
    font-size: 15px;
    line-height: 20px;
    color: #000;
    text-align: left;
}
.form-container .form-row .subtitle {
    color: #707070;
}
.form-container .categories-container .category {
    margin-bottom: 15px;
}
.form-container .categories-container .category .category-label {
    margin-bottom: 15px;
    font-size: 13px;
    line-height: 18px;
    color: #707070;
    text-align: left;
}
.digital-marketing-options {
    display: flex;
    flex-direction: row;
    flex: 0 0 50%;
    justify-content: space-between;
    flex-wrap: wrap;
}
.digital-marketing-options .option {
    width: 50%;
    margin-bottom: 26px;
}
.digital-marketing-options .option label {
    font-size: 13px;
    line-height: 18px;
    color: #000;
    padding-left: 30px;
}
.update-signup {
    align-self: flex-end;
    width: 40%;
    margin-top: 10px;
}

.error {
    margin-top: 10px;
}

.btn-end {
    align-self: flex-end;
}

[type='checkbox'].filled-in:not(:checked) + label:after {
    border: 1px solid #707070 !important;
}

[type="radio"]:not(:checked), [type="radio"]:checked {
    opacity: 1;
    position: relative;
    margin-right: 6px;
}

.radios-label {
    display: flex;
    gap: 16px;
}

.radios-label label {
    font-size: 14px;
    font-weight: bold;
    color: #000;
}

.header-radios {
    margin-bottom: 0px !important;
}

@media screen and (max-width: 1366px) {
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 992px) {
}
</style>
